"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProcessId = getProcessId;
exports.getSparxEnv = getSparxEnv;
exports.getTabId = getTabId;
var _isNullOrUndefined = _interopRequireDefault(require("./isNullOrUndefined"));
function getTabId() {
  var sparxProcess = document.querySelector('#page-tabs .tab-pane.active sparx-process');
  if ((0, _isNullOrUndefined.default)(sparxProcess)) return null;
  return sparxProcess.getAttribute('id');
}
function getProcessId() {
  try {
    var sparxProcess = document.querySelector('#page-tabs .tab-pane.active sparx-process');
    if ((0, _isNullOrUndefined.default)(sparxProcess)) return null;
    var hmnJSONdata = JSON.parse(sparxProcess.getAttribute('hmnJSONdata'));
    return hmnJSONdata.microProcessId;
  } catch (e) {
    console.log('getProcessId', e);
    return e;
  }
}
function getSparxEnv() {
  try {
    var sparxCore = document.querySelector('sparx-module#sparx-core');
    if ((0, _isNullOrUndefined.default)(sparxCore)) return null;
    var data = JSON.parse(sparxCore.getAttribute('data'));
    return data.environment;
  } catch (e) {
    console.log('getProcessId', e);
    return e;
  }
}